import { defineAction } from '~/prix'
import { z } from 'zod'
import creditSoldProductCreateAction from './creditSoldProductCreate.action.json' with { type: 'json' }
import { creditSoldProductCreateInputObject, creditSoldProductObject } from '../creditSoldProductObject'

const creditSoldProductCreateDefinition = defineAction({
  ...creditSoldProductCreateAction,

  input: creditSoldProductCreateInputObject,
  output: z.object({ id: creditSoldProductObject.shape.id }),
})

export default creditSoldProductCreateDefinition

